import { mutationTree, actionTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'

export const ELIGIBLE_SCHOLARSHIP_COUNT = 'eligibleScholarshipCount'
export const NOT_SEEN_SCHOLARSHIP_COUNT = 'notSeenScholarshipCount'

export const state = () => ({
  [ELIGIBLE_SCHOLARSHIP_COUNT]: null as null | number,
  [NOT_SEEN_SCHOLARSHIP_COUNT]: null as null | number
})

export const mutations = mutationTree(
  state,
  {
    setState
  }
)

export const actions = actionTree(
  { state, mutations },
  {
    getEligibilities({ commit }, fieldNames) {
      if (!fieldNames || !Array.isArray(fieldNames) || !fieldNames.length) { throw new Error('Please provide correct field set') }

      return this.$api.eligibilityCache
        .retrieve({ fields: fieldNames })
        .then((response: Axios.AxiosResponse) => {
          const data = response.data.data

          fieldNames.forEach((name) => {
            commit('setState', { stateName: name, data: data[name] })
          })
        })
        .catch((response: any) => Error(response))
    },
    updateEligibilities({ commit }, ids) {
      if (!ids || !Array.isArray(ids) || !ids.length) { throw new Error('Please provide correct id set') }

      return this.$api.eligibilityCache
        .update({ last_shown_scholarship_ids: ids })
        .then(() => commit('setState', {
          stateName: NOT_SEEN_SCHOLARSHIP_COUNT,
          data: 0
        }))
    }
  }
)
